Drupal.behaviors.sw_webform_connecture_provider = {
  attach: function( context, settings ) {
    $('.webform-connecture-provider').sw_webform_connecture_provider();
    $('.webform-submission-form').data('webform-connecture-provider-initialized', 1);
  }
};

$(document).on('state:required', function (e) {
  const $t = $(e.target);
  const $cp = $t.find('.webform-connecture-provider');
  if ($cp.length) {
    const $i = $cp.find('input[name$="[address2]"]');
    const $l = $i.closest('.js-form-item, .js-form-wrapper').find('label[for="'+$i.attr('id')+'"]');
    $l.removeClass('js-form-required form-required');
  }
});

$.fn.sw_webform_connecture_provider = function() {
  let wcp;
  $(this).each(function() {
    wcp = $(this).data('sw-webform-connecture-provider');
    if ( !wcp ) {
      wcp = new SwWebformConnectureProvider($(this));
    }
    wcp.update();
  });
  return wcp;
};

let webform_connecture_provider_is_ignore_primary_checkbox_event = false;

class SwWebformConnectureProvider {

  constructor($w) {
    const _this = this;

    this.$w = $w;
    this.$selected_info = this.$w.find('.webform-connecture-provider__selected-info');
    this.id = this.$w.attr('id');
    this.fields_manual = [
      'first_name',
      'last_name',
      'name',
      'phone',
      'visits',
      'address',
      'address2',
      'city',
      'state',
      'zip',
      'qty',
      'period',
      // 'is_primary',
    ];
    this.fields_selected = [
      'specialty',
      'specialty2',
      'connecture_id',
      'connecture_location_id',
      'connecture_dosage_id',
      'connecture_reference_ndc',
    ];
    this.is_force_manual = false;

    this.$w.find('.webform-connecture-provider__button-replace').on('click', function( e ) {
      e.preventDefault();
      _this.reset_state();
    });

    this.$w.find('.webform-connecture-provider__button-manually').on('click', function( e ) {
      e.preventDefault();
      _this.manual_init();
    });

    this.$w.find('.webform-connecture-provider__primary-check input[type="checkbox"]').on('change', function( e ) {
      if ( webform_connecture_provider_is_ignore_primary_checkbox_event ) {
        return;
      }
      const $i = $(this);
      const $others = _this.$w.closest('.webform-multiple-table').find('.webform-connecture-provider__primary-check input[type="checkbox"]').not($i);
      // If checked
      if ( $i.is(':checked')) {
        // Uncheck others
        webform_connecture_provider_is_ignore_primary_checkbox_event = true;
        $others.prop('checked', false).trigger('change');
        webform_connecture_provider_is_ignore_primary_checkbox_event = false;
      } else {
        // Unable to uncheck last
        let is_others_checked = false;
        $others.each(function() {
          if ( $(this).is(':checked')) {
            is_others_checked = true;
            return false;
          }
        });
        if ( !is_others_checked ) {
          webform_connecture_provider_is_ignore_primary_checkbox_event = true;
          $i.prop('checked', true).trigger('change');
          webform_connecture_provider_is_ignore_primary_checkbox_event = false;
        }
      }
    });

    this.$w.data('sw-webform-connecture-provider', this);
    this.update();

    // If element was added after page initialization (only apply to the last element in the list, and if have no value)
    if (
      this.$w.closest('.webform-submission-form').data('webform-connecture-provider-initialized')
      && this.$w.closest('tr').is(':last-child')
      && !this.has_value()
    ) {
      // Open modal search, if any
      setTimeout(function() {
        _this.$w.find('.as-b.use-ajax').trigger('click');
      }, 100);
    }
  }

  find_input(name) {
    return this.$w.find('input,select').filter('[name$="['+name+']"]');
  }

  is_any_manual_has_value () {
    for ( let i in this.fields_manual ) {
      if ( this.find_input(this.fields_manual[i]).val() ) {
        return true;
      }
    }
    return false;
  }

  is_in_initial_search_state() {
    return !this.find_input('connecture_id').val() && !this.is_force_manual;
  }

  has_value () {
    return this.find_input('connecture_id').val() || this.is_any_manual_has_value();
  }

  reset_state() {
    this.is_force_manual = false;
    for ( let i in this.fields_selected ) {
      this.find_input(this.fields_selected[i]).val('');
    }
    for ( let i in this.fields_manual ) {
      this.find_input(this.fields_manual[i]).val('');
    }
    this.update();
  }

  manual_init () {
    this.is_force_manual = true;
    for ( let i in this.fields_selected ) {
      this.find_input(this.fields_selected[i]).val('');
    }
    this.update();
  }

  manual_flash() {
    const _this = this;
    const $manual_wrap = this.$w.find('.webform-connecture-provider__form');
    $manual_wrap.addClass('webform-connecture-provider__form--flash');
    setTimeout(function() {
      $manual_wrap.removeClass('webform-connecture-provider__form--flash');
    }, 100);
  }

  select_fill ( info = {} ) {
    this.is_force_manual = false;

    console.log(info);
    for ( let name in info ) {
      const $i = this.find_input(name);
      $i.val(info[name]).trigger('change');
    }

    this.update();
  }

  update() {

    let s = [];
    let l = [];

    const $n = this.find_input('name');
    if ( $n.length ) {
      l.push($n.val());
    }
    const $p = this.find_input('connecture_package');
    if ( $p.length ) {
      l.push($p.val());
    }

    const $fn = this.find_input('first_name');
    const $ln = this.find_input('last_name');
    if ( $fn.length || $ln.length ) {
      l.push(this.find_input('first_name').val() + ' ' + this.find_input('last_name').val())
    }
    const $s = this.find_input('specialty');
    if ( $s.length ) {
      l.push($s.val());
    }
    const $s2 = this.find_input('specialty2');
    if ( $s2.length ) {
      l.push($s2.val());
    }
    s.push(l.filter((x) => $.trim(x)).join(', '));

    l = [];
    if ( this.find_input('address').length ) {
      l.push(this.find_input('address').val());
      l.push(this.find_input('address2').val());
      l.push(this.find_input('city').val());
      l.push(this.find_input('state').val() + ' ' + this.find_input('zip').val());
      l.push(this.find_input('phone').val());
    }
    s.push(l.filter((x) => $.trim(x)).join(', '));

    this.$selected_info.html(s.join('<br>'));

    if ( this.find_input('connecture_id').val() ) {
      this.$w.addClass('webform-connecture-provider--selected');
      this.$w.removeClass('webform-connecture-provider--manual');
    } else if ( this.is_force_manual || this.is_any_manual_has_value()) {
      this.$w.addClass('webform-connecture-provider--manual');
      this.$w.removeClass('webform-connecture-provider--selected');
    } else {
      this.$w.removeClass('webform-connecture-provider--manual');
      this.$w.removeClass('webform-connecture-provider--selected');
    }

    this.$w.find('.webform-connecture-provider__primary-check input[type="checkbox"]').trigger('change');

    // "Add More" login
    const $add_more = this.$w.closest('.form-type-webform-multiple').find('.webform-multiple-add');
    // Check if last
    if ( this.$w.closest('tr').is(':last-child')) {
      // If in "search" state
      if ( this.is_in_initial_search_state()) {
        // Hide "Add More"
        $add_more.hide();
      } else {
        $add_more.show();
      }
    }

  }
}
